exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-align {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/node_modules/@angular/cli/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/node_modules/@angular/cli/node_modules/postcss-loader?{"ident":"postcss"}!/Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/styles/custom.css
// module id = ../../node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../node_modules/postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles/custom.css
// module chunks = styles